/**
 * Adaptive auction countdown formatter.
 * See docs/auction-countdown-ux-spec.md for UX rationale and rules.
 */

export type AuctionCountdownLabels = {
  d: string;
  h: string;
  m: string;
  s: string;
};

export const DEFAULT_AUCTION_COUNTDOWN_LABELS: AuctionCountdownLabels = {
  d: "d",
  h: "h",
  m: "m",
  s: "s",
};

export function formatAuctionCountdown(
  remainingSeconds: number,
  labels: AuctionCountdownLabels = DEFAULT_AUCTION_COUNTDOWN_LABELS,
): string {
  const sec = Math.floor(remainingSeconds);
  if (sec <= 0) return "";

  const MIN = 60;
  const HOUR = 3600;
  const DAY = 86400;

  if (sec >= DAY) {
    const d = Math.floor(sec / DAY);
    const h = Math.floor((sec % DAY) / HOUR);
    const m = Math.floor((sec % HOUR) / MIN);
    return `${d}${labels.d} ${String(h).padStart(2, "0")}${labels.h} ${String(m).padStart(2, "0")}${labels.m}`;
  }
  if (sec >= HOUR) {
    const h = Math.floor(sec / HOUR);
    const m = Math.floor((sec % HOUR) / MIN);
    const s = sec % MIN;
    const hh = String(h).padStart(2, "0");
    const mm = String(m).padStart(2, "0");
    const ss = String(s).padStart(2, "0");
    return `${hh}${labels.h} ${mm}${labels.m} ${ss}${labels.s}`;
  }
  if (sec >= MIN) {
    const m = Math.floor(sec / MIN);
    const s = sec % MIN;
    const mm = String(m).padStart(2, "0");
    const ss = String(s).padStart(2, "0");
    return `${mm}${labels.m} ${ss}${labels.s}`;
  }
  const ss = String(sec).padStart(2, "0");
  return `${ss}${labels.s}`;
}
